import { render, staticRenderFns } from "./UsarComprobante.vue?vue&type=template&id=199456f5"
import script from "./UsarComprobante.vue?vue&type=script&lang=js"
export * from "./UsarComprobante.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports